import React from 'react';

import Input from '../Input';

function RadioInput({id, label, question, values, onChange, invalid}) {
  return (
    <Input
      id={id ? id : `answer-${question.id}`}
      label={label}
      type="select"
      value={values.length > 0 ? values[0] : ''} 
      onChange={e => onChange([e.target.value], e.target.value !== '')} 
      invalid={invalid}>
      {values.length === 0 && <option value="">Choose an option...</option>}
      {question.questionOptions.map(option => (
        <option key={option.value} value={option.value}>{option.value}</option>
      ))}
    </Input>
  );
}

export default RadioInput;
